const buttonConfigs = [
  {
    buttonClass: 'wizzy-two-products-per-row',
    bodyClass: 'wizzy-two-products-per-row',
    tileViewLevel: '3'
  },
  {
    buttonClass: 'wizzy-three-products-per-row',
    bodyClass: 'wizzy-three-products-per-row',
    tileViewLevel: '4'
  },
  {
    buttonClass: 'wizzy-single-products-per-row',
    bodyClass: 'wizzy-single-products-per-row',
    tileViewLevel: '1'
  }
];

var searchBar = document.querySelectorAll('input#Search.search__input')[2];

  if (searchBar) {
    searchBar.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
      window.scrollTo(0,0);
    var searchInput = document.querySelector('input#Search.input-text.search-query.wizzy-search-input');
    // searchInput.click();
    
    var searchPage = document.getElementById('search_mini_form');
    searchPage.style.display = 'block';
      var tapped = searchPage.querySelector('.wizzy-search-form-wrapper')
      if (tapped) {
          tapped.classList.add('mobileTapped')
      }
    if (searchInput) {
      searchInput.focus();
      searchInput.click();
    }

    window.scrollTo(0,0);

    
  });
}

var searchIcon = document.querySelector('a.site-nav__link.site-nav__link--icon.js-search-header');

if (searchIcon) {
  searchIcon.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    var searchInput = document.querySelector('input#Search.input-text.search-query.wizzy-search-input')
    if (searchInput) {
      searchInput.click();
    }
    
    var searchPage = document.getElementById('search_mini_form');
    searchPage.style.display = 'block';
    if (searchInput) {
      searchInput.focus();
    }

    
  });
}

var searchIconNoRedirect = document.querySelectorAll('.btn--search')[2];

if (searchIconNoRedirect) {
  searchIconNoRedirect.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {

      console.log("wiz init");
      data.store.currency.symbol = "QAR ";

      data.search.configs.facets.leftFacets.mobileCollapsible = true;

      data.filters.configs.keepOpenedInMobileAfterApply = true;

      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1e3,
          mobile: 2e3
      };

      data.search.view.templates.facets.gridFilterCommon = "#wizzy-grid-facet-block";

      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("main");

      data.search.configs.general.minQueryLength = 1;
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
    

    let x = document.querySelector(".wizzy-body-end-wrapper");
    if(x && typeof data.isForDefault !== 'undefined' && data.isForDefault === true) {
      x.classList.add("wizzy-view-more-hide");
    }else if(x && x.classList.contains("wizzy-view-more-hide")) {
      x.classList.remove("wizzy-view-more-hide");
    }
    
    return data;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {

      buttonConfigs.forEach(config => {
        let button = document.querySelector(`button.grid-view-btn.${config.buttonClass}`);
        if (window.innerWidth > 768) {
          button = document.querySelector(`.wizzy-desktop-only button.grid-view-btn.${config.buttonClass}`);
        }
        const searchWrapper = document.querySelector('.wizzy-search-wrapper');
      
        if (button && searchWrapper) {
          button.addEventListener('click', function() {
            document.body.classList.remove('wizzy-two-products-per-row', 'wizzy-three-products-per-row', 'wizzy-single-products-per-row');
            
            document.body.classList.add(config.bodyClass);
            
            searchWrapper.setAttribute('wizzy-tile-view-level', config.tileViewLevel);
            
            document.querySelectorAll('button.grid-view-btn').forEach(btn => btn.classList.remove('is-active'));
            button.classList.add('is-active');
          });
        }
      });

      var hiddenDivs = document.querySelectorAll("#wizzy-review-hidden");
      hiddenDivs.forEach(function (div) {
        var innerValue = div.innerText;
        var nearestDiv = div.nextElementSibling;

        if (nearestDiv) {
          nearestDiv.innerHTML = innerValue;
          var avgRating = nearestDiv
            .querySelector(".jdgm-prev-badge")
            .getAttribute("data-average-rating");
          avgRating = parseFloat(avgRating).toFixed(1);
          var badgeTextElement = nearestDiv.querySelector(
            ".jdgm-prev-badge__text"
          );
          var avgRattingSpan = null;

          if (badgeTextElement) {
            // console.log("WIZ JUDGE ME", badgeTextElement);
            avgRattingSpan = document.createElement("span");
            avgRattingSpan.className = "avgRating";
            avgRattingSpan.innerText = avgRating;

            var totalreviewSpan = document.createElement("span");
            totalreviewSpan.className = "totalReviews";
            totalreviewSpan.innerText = badgeTextElement.innerText;

            badgeTextElement.innerText = "";

            badgeTextElement.appendChild(avgRattingSpan);
            badgeTextElement.appendChild(totalreviewSpan);
          }
        }
      });

      var sourceElement = document.querySelector('.wizzy-search-sort-wrapper');
    
        if (sourceElement) {
            var clonedContent = sourceElement.cloneNode(true);
            
            var targetDiv = document.querySelector('.wizzy-sort-wrapper-in-filter');
            
            if (targetDiv && !targetDiv.querySelector('.wizzy-search-sort-wrapper')) {
                targetDiv.appendChild(clonedContent);
            }
        }

        if (window.innerWidth < 768) {
          var sortInFilter = document.querySelector('.wizzy-search-filters-left-wrapper .wizzy-common-select-selector');
          if (sortInFilter && !sortInFilter.classList.contains('click-listener-attached')) {
              sortInFilter.addEventListener('click', function(event){
                  event.preventDefault();
                  event.stopPropagation();
                  var sortOptions = document.querySelector('.wizzy-common-select-options');
                  if (sortOptions) {
                      if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                          sortOptions.style.display = 'grid';
                      } else {
                          sortOptions.style.display = 'none';
                      }
                  }
              });
              sortInFilter.classList.add('click-listener-attached');
          }

          var filtersWrapper = document.querySelector('.wizzy-search-filters-left');
        
            if (filtersWrapper) {
                    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
                        filtersWrapper.classList.add('wizzy-filters-wrapper-scrolled');
                    } else {
                        filtersWrapper.classList.remove('wizzy-filters-wrapper-scrolled');
                    }
            }

          window.addEventListener('scroll', function() {
            var filtersWrapper = document.querySelector('.wizzy-search-filters-left');
        
            if (filtersWrapper) {
                    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
                        filtersWrapper.classList.add('wizzy-filters-wrapper-scrolled');
                    } else {
                        filtersWrapper.classList.remove('wizzy-filters-wrapper-scrolled');
                    }
            }
          });
      }

      var quickAddbtns = document.querySelectorAll('.wizzy-result-product.grid-item [data-single-variant-quick-add]');

      if (quickAddbtns.length > 0) {
        quickAddbtns.forEach((ATCbtn) => {
          if (!ATCbtn.classList.contains('wizzy-atc-event-attached')) {
            ATCbtn.addEventListener('click', function(evt) {
              evt.preventDefault();
              evt.stopPropagation();
              addToCart(evt);
            });
      
            ATCbtn.classList.add('wizzy-atc-event-attached');
          }
        });
      }

      
      return data;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {

      data.forEach((product) => {
        product.judgemereview = "";
        product.frontEndLabel = "";
            if (product.attributes) {
              product.attributes.forEach((attribute) => {
                 if (attribute.id === "product_badge_judgeme") {
                      
                   if (attribute.values) {
                     if (attribute.values[0].value[0]) {
                       product.judgemereview = attribute.values[0].value[0];
                     }
                   }
                   // console.log("wiz1 ", product.judgemereview);
                  }
                if (attribute.id === "product__label_tags") {
                      
                  if (attribute.values) {
                    if (attribute.values[0].value[0]) {
                      product.frontEndLabel = attribute.values[0].value[0];
                    }
                  }
                  // console.log("wiz 2", product.frontEndLabel);
                  }
            })
          }
      });

      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {

      var backIcon = document.querySelector('.wizzy-search-back');

      if (backIcon) {
        backIcon.click();
      }

      var searchBar = document.querySelector('form#search_mini_form');

      if (searchBar) {
        searchBar.style.display = "none";
      }

      var predictiveSearchWrapper = document.querySelectorAll('predictive-search')[2];

      if (predictiveSearchWrapper) {
        predictiveSearchWrapper.classList.remove("is-active")
      }

      var predictiveSearchWrapperWeb = document.querySelectorAll('predictive-search')[0];

      if (predictiveSearchWrapperWeb) {
        predictiveSearchWrapperWeb.classList.remove("is-active")
      }

      
      return data;
    }
  );

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-common-select");
  changeTemplate("wizzy-search-wrapper");
  
};

if (window.innerWidth > 768) {
  window.addEventListener('scroll', function() {
    var autoCompleteWrapper = document.querySelector('.wizzy-body-end-wrapper');

    if (autoCompleteWrapper) {
            if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
                autoCompleteWrapper.classList.add('wizzy-autocomplete-wrapper-scrolled');
            } else {
                autoCompleteWrapper.classList.remove('wizzy-autocomplete-wrapper-scrolled');
            }
    }
  });
}

if (window.innerWidth > 1500) {
  window.addEventListener('scroll', function() {
    var autoCompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');

    if (autoCompleteWrapper) {
      var predictiveSearch = document.querySelector('predictive-search');
      if (predictiveSearch) {
        var positionInfo = predictiveSearch.getBoundingClientRect();
        var left = positionInfo.left;
        var top = positionInfo.top + positionInfo.height;
        autoCompleteWrapper.style.setProperty('top', top + 'px', 'important');
        autoCompleteWrapper.style.setProperty('left', left + 'px', 'important');
      }
    }
  });
}

if (window.innerWidth > 1500) {
      var predictiveSearch = document.querySelector('predictive-search input');
      if (predictiveSearch) {
        predictiveSearch.addEventListener('click', function(){
          var positionInfo = predictiveSearch.getBoundingClientRect();
          var left = positionInfo.left;
          var top = positionInfo.top + positionInfo.height;
          
          setTimeout(function(){
            var autoCompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');
            if (autoCompleteWrapper) {
              autoCompleteWrapper.style.setProperty('top', top + 'px', 'important');
              autoCompleteWrapper.style.setProperty('left', left + 'px', 'important');
            }
          }, 200);
        });
      }
}

function changeTemplate(div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
}

function addToCart(evt) {
    const btn = evt.currentTarget,
          visibleBtn = btn.querySelector(".btn"),
          id = btn.dataset.id;

    visibleBtn.classList.add("btn--loading");

    const data = {
        items: [{
            id,
            quantity: 1
        }]
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then(response => response.json())
    .then(data2 => {
        if (data2.status === 422 || data2.status === "bad_request") {
            if (data2.description) alert(data2.description);
        } else {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    product: data2,
                    addToCartBtn: btn
                }
            }));
        }
        visibleBtn.classList.remove("btn--loading");
    });
}